import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AlertService } from '@app/_services';
import { SharedService } from '../_shared/shared.service';
import { QualityTestDefinition } from './quality-test-definition';
import { QualityTestFieldRegistry } from './quality-test-field-registry';

@Injectable({ providedIn: 'root' })
export class QualityTestDefinitionsService {

  urlEndpoint = 'quality-test-definitions';
  fieldRegistryEndpoint = 'quality-test-field-registry';

  constructor(
    private http: HttpClient,
    private alertService: AlertService,
    private sharedService: SharedService,
  ) { }

  findAll(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta: any, globalFilter: any, filters: any): Observable<ApiResponse> {
    const params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params }).pipe(retry({ count: 2, delay: 1500 }));
  }

  findById(id: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
  }

  add(def: QualityTestDefinition): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, def);
  }

  update(def: QualityTestDefinition): Observable<ApiResponse> {
    return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, def);
  }

  delete(id: number): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`);
  }

  interpret(text: string): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/interpret`, { text });
  }

  findAllFields(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.fieldRegistryEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
  }

  addField(field: QualityTestFieldRegistry): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.fieldRegistryEndpoint}`, field);
  }

  updateField(field: QualityTestFieldRegistry): Observable<ApiResponse> {
    return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.fieldRegistryEndpoint}`, field);
  }

  deleteField(id: number): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.fieldRegistryEndpoint}/${id}`);
  }

  /** Aggregated dashboard payload — by category + per-property roll-ups. */
  getDashboard(categoryPathPrefix?: string): Observable<ApiResponse> {
    const url = `${environment.apiUrl}/quality-tests/dashboard${categoryPathPrefix ? '?categoryPathPrefix=' + encodeURIComponent(categoryPathPrefix) : ''}`;
    return this.http.get<ApiResponse>(url).pipe(retry({ count: 2, delay: 1500 }));
  }
}
